import domReady from '@wordpress/dom-ready';

domReady(() => {
  if ('undefined' !== typeof window.FWP) {
    document.addEventListener('facetwp-loaded', function () {
      const mapContainer = document.querySelector(
        '.facetwp-facet-resources_map'
      );
      if (0 === window.FWP_MAP.markersArray.length) {
        mapContainer.classList.add('facetwp-hidden');
      } else {
        mapContainer.classList.remove('facetwp-hidden');
      }
    });
    document.addEventListener('facetwp-reset', function () {
      const mapContainer = document.querySelector(
        '.facetwp-facet-resources_map'
      );
      if (0 === window.FWP_MAP.markersArray.length) {
        mapContainer.classList.add('facetwp-hidden');
      } else {
        mapContainer.classList.remove('facetwp-hidden');
      }
    });
  }
});
